module.exports = __webpack_public_path__ + "static/img/sample-banner.d454807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novel-coronavirus/sample-banner.png
// module id = Vm0R
// module chunks = 1